import { render, staticRenderFns } from "./DotSeparator.vue?vue&type=template&id=971966da&scoped=true&"
import script from "./DotSeparator.vue?vue&type=script&lang=js&"
export * from "./DotSeparator.vue?vue&type=script&lang=js&"
import style0 from "./DotSeparator.vue?vue&type=style&index=0&id=971966da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971966da",
  null
  
)

export default component.exports